import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/pro-regular-svg-icons";

interface Props {
  total?: number;
  page: number;
  pathname: string;
  params?: any;
}

export function AppPagination({ total = 0, page, pathname, params }: Props) {
  const currentPage = page;
  const blockSize = 5;

  const currentBlock = Math.ceil(currentPage / blockSize);
  const totalBlock = Math.ceil(total / blockSize);

  const startPage = (currentBlock - 1) * blockSize + 1;
  const endPage = currentBlock * blockSize;

  const prevBlockPage = startPage - 1;
  const nextBlockPage = endPage + 1;

  const Item = () => {
    const items = [];

    for (let i = startPage; i <= endPage && i <= total; i++) {
      items.push(
        <li
          key={i}
          className={`regular-text-18 w-10 md:min-w-14 flex justify-center items-center rounded-full h-10 md:h-14 text-md-15 ${
            i === page
              ? "text-white bg-[#292841]"
              : "text-[#8a8990] bg-[#fbfbfb]"
          }`}
        >
          <Link href={{ pathname, query: { ...params, page: i } }}>{i}</Link>
        </li>
      );
    }

    return items;
  };

  return (
    <ul className="flex items-center justify-center gap-3">
      {currentBlock > 1 && (
        <li className=" w-10 md:min-w-14 flex justify-center items-center text-white bg-[#F7F7F7] rounded-full md:w-14 h-10 md:h-14 text-md md:text-lg">
          <Link
            href={{
              pathname,
              query: { ...params, page: prevBlockPage },
            }}
          >
            <FontAwesomeIcon icon={faChevronLeft} className="text-[#9CA9C2]" />
          </Link>
        </li>
      )}

      <Item />

      {currentBlock < totalBlock && (
        <li className=" w-10 md:min-w-14 flex justify-center items-center text-white bg-[#F7F7F7] rounded-full md:w-14 h-10 md:h-14 text-md md:text-lg">
          <Link
            href={{
              pathname,
              query: { ...params, page: nextBlockPage },
            }}
          >
            <FontAwesomeIcon icon={faChevronRight} className="text-[#9CA9C2]" />
          </Link>
        </li>
      )}
    </ul>
  );
}
